import {
  NotificationTemplate,
  NotificationType,
} from '../../../shared/models/notification.model'
import {
  useAddNotificationTemplateMutation,
  useUpdateNotificationTemplateMutation,
} from '../../../store/kopiliot-api/notification-template'
import { Controller, useForm } from 'react-hook-form'
import React from 'react'
import { toast } from 'react-toastify'
import { Button, Col, Form, Modal } from 'react-bootstrap'
import ButtonLoading from '../../../components/button/ButtonLoading'
import { useAppSelector } from '../../../store/store'
import Input from '../../../components/form/Input'
import SelectBase from '../../../components/page-components/selects-entities/generic-select/SelectBase'
import { SelectableValue } from '../../../components/page-components/selects-entities/generic-select/selectable-value'

interface Props {
  show?: boolean
  onHide: () => void
  entity?: Partial<NotificationTemplate>
}

const AddOrEditNotificationTemplate = ({ show, onHide, entity }: Props) => {
  const user = useAppSelector((root) => root.currentUser)

  const [add, result] = useAddNotificationTemplateMutation()
  const [update, resultUpdate] = useUpdateNotificationTemplateMutation()

  const form = useForm<NotificationTemplate>({
    defaultValues: {
      config: {
        emailTemplate: {
          enabled: false,
        },
        webTemplate: {
          enabled: false,
        },
        smsTemplate: {
          enabled: false,
        },
      },
      tenantID: user.tenantID,
    },
  })

  React.useEffect(() => {
    if (entity && entity.id) {
      form.reset(entity)
    }
  }, [entity])
  const watchConfig = form.watch('config')
  const onSubmit = async (data: NotificationTemplate) => {
    try {
      if (data.id) {
        await update(data).unwrap()
        toast.success('Template mis à jour avec succès')
      } else {
        await add(data).unwrap()
        toast.success('Template ajouté avec succès')
      }

      onHide()
    } catch (e) {
      console.log(e)
    }
  }
  const isLoading = result.isLoading || resultUpdate.isLoading

  return (
    <Modal show={show} onHide={onHide} size={'xl'} centered>
      <Modal.Header>
        <Modal.Title>{`${
          entity?.id ? 'Editer' : 'Ajouter'
        } un template`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate {...form}>
          <Input register={form.register('name')} label={'Nom'} />
          <Input
            type={'textarea'}
            register={form.register('description')}
            label={'Description'}
          />
          <div className={'mt-2'}>
            <Form.Group as={Col} lg={6} md={12}>
              <Form.Label htmlFor={'notificationType'}>
                Type de notification
              </Form.Label>
              <Controller
                control={form.control}
                name={'notificationType'}
                rules={{ required: 'Séléctionnez un type' }}
                render={({ field }) => {
                  return (
                    <SelectBase
                      isLoading={false}
                      placeholder={'Rechercher...'}
                      options={[
                        {
                          value: NotificationType.GENERAL,
                          label: 'General',
                        },
                        {
                          value: NotificationType.RULE_NODE,
                          label: 'Rule node',
                        },
                        {
                          value: NotificationType.ENTITY_ACTION,
                          label: 'Entity Action',
                        },
                      ]}
                      onInputChange={(value) => {
                        //setSearch(value)
                      }}
                      isClearable={true}
                      debounceDelay={1000}
                      minCharsForSearch={2}
                      value={field.value ? { value: field.value } : undefined}
                      onChange={(value: SelectableValue<NotificationType>) => {
                        if (value) {
                          field.onChange(value?.value)
                        }
                      }}
                      valueComparator={(a, b) => {
                        return a?.value === b?.value
                      }}
                      errorMessage={
                        form.formState.errors?.notificationType?.message
                      }
                    />
                  )
                }}
              />
            </Form.Group>
          </div>
          <div className={'mt-2'}>
            <Input
              label={'Email'}
              className={'ms-2'}
              type={'switch'}
              register={form.register('config.emailTemplate.enabled')}
            />
            {watchConfig.emailTemplate.enabled && (
              <div>
                <Input
                  register={form.register('config.emailTemplate.subject')}
                  label={'Sujet'}
                />
                <Input
                  type={'textarea'}
                  register={form.register('config.emailTemplate.body')}
                  label={'Corps'}
                />
              </div>
            )}
            <Input
              label={'Web'}
              className={'ms-2'}
              type={'switch'}
              register={form.register('config.webTemplate.enabled')}
            />
            {watchConfig.webTemplate.enabled && (
              <div>
                <Input
                  register={form.register('config.webTemplate.subject')}
                  label={'Sujet'}
                />
                <Input
                  type={'textarea'}
                  register={form.register('config.webTemplate.body')}
                  label={'Corps'}
                />
              </div>
            )}
            <Input
              label={'SMS'}
              className={'ms-2'}
              type={'switch'}
              register={form.register('config.smsTemplate.enabled')}
            />
            {watchConfig.smsTemplate.enabled && (
              <div>
                <Input
                  type={'textarea'}
                  register={form.register('config.smsTemplate.body')}
                  label={'Corps'}
                />
              </div>
            )}
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button type={'button'} variant={'outline-secondary'} onClick={onHide}>
          Annuler
        </Button>
        <ButtonLoading
          isLoading={isLoading}
          disabled={isLoading}
          variant={'outline-primary'}
          type={'submit'}
          text={'Valider'}
          onClick={form.handleSubmit(onSubmit)}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default AddOrEditNotificationTemplate
